<template>
  <div class="snackbar_container">
    <img src="/static/icons/green_check.svg"/>
    <p class="body_7_M f_gray_12">{{ text }}</p>
  </div>
</template>

<script>

export default {
  props: {
    text: {
      type: String
    }
  }
}
</script>

<style scope>
.snackbar_container {
  position: fixed;
  bottom: 84px;
  width: calc(100vw - 40px);
  max-width: 728px;
  background-color: rgba(40, 42, 46, 0.8);
  padding: 12px 24px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  gap: 8px;
  animation: 3s hide-d forwards;
  left: 50%;
  transform: translateX(-50%);

}
  @keyframes hide-d {
    0% {
      opacity: 0;
    } 20% {
      opacity: 1;
    } 80% {
      opacity: 1;
    } 100% {
      opacity: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ai/AiSnackbar.vue